module.exports = __webpack_public_path__ + "static/img/shareBg.c52a785.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/shareBg.png
// module id = Uojs
// module chunks = 99